import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface HeaderProps {
  onlineCount: number;
}

export default function Header({ onlineCount }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a0a0f]/95 backdrop-blur-lg shadow-lg shadow-black/50' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img src="https://public.readdy.ai/ai/img_res/6187dda7-4ee3-4144-a653-0e0d186c3a43.png" alt="Live Casino Logo" className="w-12 h-12 object-contain" />
            <span className="text-2xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent">
              Live Casino 2026
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-white hover:text-[#d4af37] transition-colors font-medium">
              Главная
            </Link>
            <Link to="/rating" className="text-white hover:text-[#d4af37] transition-colors font-medium">
              Рейтинг казино
            </Link>
            <Link to="/providers" className="text-white hover:text-[#d4af37] transition-colors font-medium">
              Провайдеры
            </Link>
          </nav>

          <div className="flex items-center gap-4">
            <div className="hidden lg:flex items-center gap-2 bg-[#242429] px-4 py-2 rounded-full">
              <div className="w-2 h-2 bg-[#2ecc71] rounded-full animate-pulse"></div>
              <span className="text-sm text-gray-300">Онлайн:</span>
              <span className="text-sm font-bold text-[#d4af37]">{onlineCount.toLocaleString()}</span>
            </div>

            <button 
              className="md:hidden text-white text-2xl"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-4 border-t border-gray-800 pt-4">
            <Link to="/" className="text-white hover:text-[#d4af37] transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>
              Главная
            </Link>
            <Link to="/rating" className="text-white hover:text-[#d4af37] transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>
              Рейтинг казино
            </Link>
            <Link to="/providers" className="text-white hover:text-[#d4af37] transition-colors font-medium" onClick={() => setMobileMenuOpen(false)}>
              Провайдеры
            </Link>
            <div className="flex items-center gap-2 bg-[#242429] px-4 py-2 rounded-full w-fit">
              <div className="w-2 h-2 bg-[#2ecc71] rounded-full animate-pulse"></div>
              <span className="text-sm text-gray-300">Онлайн:</span>
              <span className="text-sm font-bold text-[#d4af37]">{onlineCount.toLocaleString()}</span>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}